document.addEventListener("DOMContentLoaded", function () {



   // Marquee

   const m768 = matchMedia("(width < 768px)");
   const $photoCarousel = $('.marquee-photos');
   const carouselOptions = {
    //duration in milliseconds of the marquee
    duration: 40500,

    //gap in pixels between the photo-carousels
    gap: 0,
    startVisible: true,
    //time in milliseconds before the marquee will start animating
    delayBeforeStart: 0,
    //'left' or 'right'
    direction: "left",
    //true or false - should the marquee be duplicated to show an effect of continues flow
    duplicated: true,
  };
 
   const handleMarquee = () => {
     if (m768.matches && !$photoCarousel.data("marqueeinit")) {
       
      $photoCarousel.data("marqueeinit", 1);
      $photoCarousel.marquee(carouselOptions);
       
     }
     else if (!m768.matches && $photoCarousel.data("marqueeinit")) {
      $photoCarousel.removeData("marqueeinit");
       $photoCarousel.marquee("destroy");
     }
   };
 
   $(window).on("resize", handleMarquee);
   handleMarquee();

}); // on doc read